<template>
    <v-dialog
        v-model="$store.state.ckedi.openFileSendingPanel"
        transition="dialog-bottom-transition"
        persistent
    >
        <v-container fluid>
            <v-card>
                <v-toolbar
                    dark
                    color="secondary"
                    dense
                    style="margin-bottom: 15px;"
                >
                    <v-btn
                        icon
                        dark
                        @click="$store.state.ckedi.openFileSendingPanel = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        File Sending Panel
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-menu
                        v-model="fileOwnerMenu"
                        :close-on-content-click="false"
                        :nudge-width="100"
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-filter-menu</v-icon>
                            </v-btn>
                        </template>

                        <v-card class="mx-auto" max-width="200" tile>
                            <v-list shaped style="padding: 5px 10px;">
                                <v-subheader style="height: 30px;padding: 0;"
                                    >Filter By</v-subheader
                                >
                                <v-switch
                                    v-model="ckFiles"
                                    inset
                                    label="CK"
                                    dense
                                    hide-details
                                    @change="handleFilterBy(1)"
                                    style="margin: 0;padding-top: 6px;"
                                ></v-switch>
                                <v-switch
                                    v-model="ckQuebecFiles"
                                    inset
                                    label="CK Quebec"
                                    dense
                                    hide-details
                                    @change="handleFilterBy(2)"
                                    style="margin: 0;padding-top: 6px;"
                                ></v-switch>
                            </v-list>
                        </v-card>
                    </v-menu>
                </v-toolbar>
                <v-container fluid>
                    <v-row>
                        <v-col cols="6">
                            <v-card>
                                <v-card-title style="padding-top: 30px;">
                                    Staged Files
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="stagedFileSearch"
                                        append-icon="mdi-magnify"
                                        label="Search file"
                                        hide-details
                                        style="padding-top: 0;margin-top: 0;"
                                    ></v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-tooltip top>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                color="primary"
                                                class="white--text"
                                                @click="sendSelectedFiles"
                                                v-bind="attrs"
                                                v-on="on"
                                                style="margin: 0!important;"
                                            >
                                                Send
                                                <v-icon right dark>
                                                    mdi-file-send-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Send Selected Files</span>
                                    </v-tooltip>
                                </v-card-title>
                                <v-data-table
                                    :headers="stagedFilesHeaders"
                                    :items="filteredStagedFilesList"
                                    @click:row="selectStagedFile"
                                    dense
                                    max-height="150"
                                    fixed-header
                                    :search="stagedFileSearch"
                                    style="cursor: pointer;"
                                    :loading="stagedFilesLoading"
                                    loading-text="Loading staged files..."
                                    :item-class="itemRowBackground"
                                >
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon
                                            small
                                            class="ml-3"
                                            @click="openFile(item)"
                                        >
                                            mdi-eye
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                        <v-col cols="6">
                            <v-card>
                                <v-card-title style="padding-top: 30px;">
                                    {{
                                        ckFiles
                                            ? 'CK Remote Files'
                                            : 'CK Quebec Remote Files'
                                    }}
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="remoteFileSearch"
                                        append-icon="mdi-magnify"
                                        label="Search file"
                                        hide-details
                                        style="padding-top: 0;margin-top: 0;"
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="remoteFilesHeaders"
                                    :items="filteredRemoteFilesList"
                                    dense
                                    max-height="150"
                                    fixed-header
                                    :search="remoteFileSearch"
                                    :loading="remoteFilesLoading"
                                    loading-text="Loading remote files..."
                                >
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon
                                            small
                                            class="ml-3"
                                            @click="openFile(item)"
                                        >
                                            mdi-eye
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>

        <v-dialog
            v-model="sendSelectedFilesConfirmation"
            persistent
            max-width="700px"
            transition="dialog-bottom-transition"
        >
            <v-card style="padding: 0 20px;">
                <v-card-title style="padding-left: 0;"
                    >Please confirm</v-card-title
                >
                <v-card-text style="font-size: 16px;padding-left: 0;">
                    {{
                        ckFiles
                            ? 'You will send the following files to Circle K, do you want to continue?'
                            : 'You will send the following files to Circle K Quebec, do you want to continue?'
                    }}
                </v-card-text>
                <table style="margin-bottom: 20px;">
                    <tr>
                        <th style="font-size: 14px;">FileId</th>
                        <th style="font-size: 14px;">InvId</th>
                        <th style="font-size: 14px;">File Name</th>
                        <th style="font-size: 14px;">File Datetime</th>
                    </tr>
                    <tr v-for="(item, i) in selectedStagedFiles" :key="i">
                        <td style="font-size: 14px;">{{ item.EdiFileID }}</td>
                        <td style="font-size: 14px;">{{ item.InvId }}</td>
                        <td style="font-size: 14px;">
                            {{ item.FilenameString }}
                        </td>
                        <td style="font-size: 14px;">{{ item.FileDttm }}</td>
                    </tr>
                </table>

                <div
                    style="display: flex;justify-content: space-between;padding: 0 0 15px;"
                >
                    <v-btn color="primary" @click="sendSelectedFilesInterface">
                        Continue
                    </v-btn>
                    <v-btn text @click="sendSelectedFilesConfirmation = false">
                        Cancel
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="openDocument.showDoc"
            persistent
            fullscreen
            transition="dialog-bottom-transition"
        >
            <v-container fluid>
                <v-card>
                    <v-toolbar
                        dark
                        color="secondary"
                        dense
                        style="margin-bottom: 15px;"
                    >
                        <v-btn icon dark @click="openDocument.showDoc = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title class="white--text">
                            {{ openDocument.fileName }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="downloadDocument">
                            <v-icon>mdi-download-box</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-row>
                        <v-col cols="12" style="padding: 0;">
                            <p
                                style="font-family: monospace,monospace;padding: 20px;margin: 0;"
                            >
                                {{ openDocument.content }}
                            </p>
                        </v-col>
                    </v-row>
                </v-card>
            </v-container>
        </v-dialog>
    </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
    props: [],
    components: {},
    data: function() {
        return {
            stagedFileSearch: '',
            stagedFilesHeaders: [
                { text: 'FileId', value: 'EdiFileID' },
                { text: 'InvId', value: 'InvId' },
                { text: 'File Name', value: 'FilenameString' },
                { text: 'File Datetime', value: 'FileDttm' },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            stagedFilesList: [],
            stagedFilesLoading: false,
            fileOwnerMenu: false,
            ckQuebecFiles: false,
            ckFiles: true,
            remoteFileSearch: '',
            remoteFilesHeaders: [
                { text: 'Name', value: 'FilenameString' },
                { text: 'Date Modified', value: 'DateModified' },
                { text: 'Type', value: 'Type' },
                { text: 'Size', value: 'Size' },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            remoteFilesList: [],
            remoteFilesLoading: false,
            sendSelectedFilesConfirmation: false,
            selectedStagedFiles: [],
            openDocument: {
                showDoc: false,
                fileName: '',
                content: ''
            }
        };
    },
    computed: {
        filteredStagedFilesList: {
            get: function() {
                let filteredList = [];
                if (this.ckFiles) {
                    filteredList = this.stagedFilesList.filter(
                        file => file.MacsVendorCode == 'S0039385'
                    );
                } else if (this.ckQuebecFiles) {
                    filteredList = this.stagedFilesList.filter(
                        file => file.MacsVendorCode == '15UPT'
                    );
                }

                return filteredList;
            }
        },
        filteredRemoteFilesList: {
            get: function() {
                let filteredList = [];
                if (this.ckFiles) {
                    filteredList = this.remoteFilesList.filter(
                        file => file.VendorCode == 'S0039385'
                    );
                } else if (this.ckQuebecFiles) {
                    filteredList = this.remoteFilesList.filter(
                        file => file.VendorCode == '15UPT'
                    );
                }

                return filteredList;
            }
        }
    },
    mounted() {
        this.loadStagedFiles();
        this.loadRemoteFiles();
    },
    methods: {
        loadRemoteFiles: function() {
            this.remoteFilesLoading = true;
            axios
                .get('/ck-edi/remote-files')
                .then(response => {
                    console.log(response.data);
                    this.remoteFilesLoading = false;
                    this.remoteFilesList = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadStagedFiles: function() {
            this.stagedFilesLoading = true;
            axios
                .get('/ck-edi/staged-files')
                .then(response => {
                    console.log(response.data);
                    this.stagedFilesLoading = false;
                    this.stagedFilesList = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        sendSelectedFilesInterface: async function() {
            console.log('sendSelectedFilesInterface');
            let filesToCk = this.selectedStagedFiles.filter(
                f => f.MacsVendorCode == 'S0039385'
            );
            let filesToCkQc = this.selectedStagedFiles.filter(
                f => f.MacsVendorCode == '15UPT'
            );

            // Ensures that the files are for a single recipient only
            if (
                (this.ckFiles && filesToCkQc.length >= 1) ||
                (this.ckQuebecFiles && filesToCk.length >= 1)
            ) {
                this.$store.dispatch('setSnackbar', {
                    color: 'warning',
                    text: 'Cannot send files from another recipient.'
                });
                return;
            }

            let params = {
                FilesToSend: this.selectedStagedFiles,
                Target: this.ckFiles ? 'ck' : 'ck-quebec'
            };
            this.$store.state.isLoading = true;
            await axios
                .post('/ck-edi/documents/ftp-send', params)
                .then(response => {
                    console.log(response.data);
                    this.loadStagedFiles();
                    this.loadRemoteFiles();
                    this.$store.state.isLoading = false;
                    this.sendSelectedFilesConfirmation = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Files have been sent successfully.'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    this.sendSelectedFilesConfirmation = false;
                    if (error.response.status == 409) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Cannot send files from another recipient.'
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'The files could not be sent, please contact the IT department.'
                        });
                    }
                });
        },
        sendSelectedFiles: function() {
            //console.log("sendSelectedFiles");
            //console.log(this.filteredStagedFilesList);
            this.selectedStagedFiles = this.filteredStagedFilesList.filter(
                file => file.Selected
            );
            console.log(this.selectedStagedFiles);
            if (!this.selectedStagedFiles.length) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select at least one file.'
                });
                return;
            }
            this.sendSelectedFilesConfirmation = true;
        },
        selectStagedFile: function(file) {
            if (file.Selected) {
                file.Selected = false;
            } else {
                file.Selected = true;
            }
            console.log(file);
        },
        openFile: function(file) {
            console.log(file);
            this.createDisplayTab(file);
            //this.openDocument.showDoc = true;
            //this.openDocument.fileName = file.FilenameString;
            //this.openDocument.content = file.Content;
            //this.downloadDocument();
        },
        createDisplayTab: function(file) {
            const newTab = window.open();
            const head = `
                <title>CK EDI File</title>
            `;
            const body = `
                <h1>${file.FilenameString}</h1>
                <pre>${file.Content}</pre>
            `;
            newTab.document.head.innerHTML = head;
            newTab.document.body.innerHTML = body;
            newTab.document.close();
        },
        handleFilterBy(selectedOption) {
            if (selectedOption == 1 && this.ckFiles) {
                this.ckQuebecFiles = false;
            } else if (selectedOption == 1 && !this.ckFiles) {
                this.ckQuebecFiles = true;
            } else if (selectedOption == 2 && this.ckQuebecFiles) {
                this.ckFiles = false;
            } else if (selectedOption == 2 && !this.ckQuebecFiles) {
                this.ckFiles = true;
            }
        },
        itemRowBackground: function(item) {
            return item.Selected ? 'file-selected' : 'file-unselected';
        },
        downloadDocument: function() {
            // EDI FF - Download document in browser
            const blobEdiff = new Blob([this.openDocument.content], {
                type: 'text/plain'
            });
            const url = URL.createObjectURL(blobEdiff);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.openDocument.fileName + '.txt');
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        }
    }
};
</script>

<style>
.file-selected {
    background-color: #edd84b !important;
}
.file-unselected {
    background-color: transparent;
}
</style>
<style scoped>
.v-dialog__content--active {
    background-color: rgba(0, 0, 0, 0.7);
}

.v-dialog__content {
    opacity: 0.995;
}
table {
    border-collapse: collapse;
    width: 100%;
}
th,
td {
    border: 1px solid #dddddd;
    padding: 8px;
    text-align: left;
}
</style>
